import {
  Button,
  CircularProgress,
  Fade,
  Grid,
  Paper,
  TextField,
} from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { navigate } from "../../actions/routerResolve";
import { msgSimple } from "../../actions/snackbarActions";
import { colors } from "../../styles";
import PassengerService from "../../tools/PassengerService";
import Modal from "./Modal";

//SweetAlert
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

class ProfilePassenger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user.user,
      loading: true,
      error: false,
      buttonLoading: false,
      modal: false,
    };
  }
  componentWillMount() {
    PassengerService.getById(this.state.user.id).then((result) => {
      if (result.ok) {
        this.setState({ user: result.response.passenger, loading: false });
      } else {
        this.setState({ loading: false, error: true });
      }
    });
  }
  openModal = () => {
    this.setState({ modal: !this.state.modal });
  };

  handleSave = () => {
    Swal.fire({
      title:
        "<strong>Deseja realmente salvar as alterações realizadas?</strong>",
      type: "info",
      // html:'',
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Salvar',
      confirmButtonAriaLabel: "Salvar",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
      cancelButtonAriaLabel: "Cancelar",
    }).then(async (result) => {
      if (!!result.value) {
        this.setState({ buttonLoading: true });
        PassengerService.update(this.state.user.id, {
          ...this.state.user,
        }).then((result) => {
          if (result.ok) {
            this.props.msgSimple("Passageiro salvo com sucesso.");
            this.setState({ buttonLoading: false });
          } else {
            this.props.msgSimple(
              "Erro ao salvar. Por favor, verifique sua conexão."
            );
            this.setState({ buttonLoading: false });
          }
        });
      } else {
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
      }
    });
  };

  changePassword = (oldPassword, newPassword) => {
    PassengerService.changePassword({ oldPassword, newPassword }).then(
      (result) => {
        if (result.ok) {
          this.props.msgSimple("Senha alterada com sucesso");
          this.openModal();
        } else {
          this.props.msgSimple(
            "Erro ao alterar a senha. Por favor, verifique sua conexão."
          );
        }
      }
    );
  };

  render() {
    return (
      <Fade in={true}>
        <Grid container style={{ justifyContent: "center" }}>
          <Modal
            changePassword={this.changePassword}
            open={this.state.modal}
            openModal={() => this.openModal()}
          />
          {this.state.loading ? (
            <CircularProgress size={40} style={{ marginTop: 60 }} />
          ) : (
            <Fragment>
              <Grid
                style={{
                  textAlign: "center",
                  backgroundColor: colors.blue500,
                  height: 150,
                }}
                item
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
              ></Grid>
              <Grid
                container
                item
                xl={10}
                lg={10}
                md={10}
                sm={10}
                xs={10}
                style={{ marginTop: -30, marginBottom: 20 }}
              >
                <Paper style={{ width: "100%" }}>
                  <Grid container spacing={8} style={{ padding: 10 }}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      container
                      spacing={8}
                    >
                      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                          id="first_name"
                          label="Nome *"
                          style={{ width: "100%" }}
                          value={this.state.user.first_name}
                          onChange={(event) => {
                            let { user } = this.state;
                            this.setState({
                              user: { ...user, first_name: event.target.value },
                            });
                          }}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                          id="last_name"
                          label="Sobrenome "
                          style={{ width: "100%" }}
                          value={this.state.user.last_name}
                          onChange={(event) => {
                            let { user } = this.state;
                            this.setState({
                              user: { ...user, last_name: event.target.value },
                            });
                          }}
                          margin="normal"
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      container
                      spacing={8}
                    >
                      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                          id="email"
                          label="E-mail*"
                          style={{ width: "100%" }}
                          value={this.state.user.email}
                          onChange={(event) => {
                            let { user } = this.state;
                            this.setState({
                              user: { ...user, email: event.target.value },
                            });
                          }}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                          id="phone"
                          label="Celular"
                          style={{ width: "100%" }}
                          value={this.state.user.phone}
                          onChange={(event) => {
                            let { user } = this.state;
                            this.setState({
                              user: { ...user, phone: event.target.value },
                            });
                          }}
                          margin="normal"
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      container
                      spacing={8}
                    >
                      <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                        <TextField
                          id="rg"
                          label="RG"
                          style={{ width: "100%" }}
                          value={this.state.user.rg}
                          onChange={(event) => {
                            let { user } = this.state;
                            this.setState({
                              user: { ...user, rg: event.target.value },
                            });
                          }}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                        <TextField
                          id="cpf"
                          label="CPF"
                          style={{ width: "100%" }}
                          value={this.state.user.cpf}
                          onChange={(event) => {
                            let { user } = this.state;
                            this.setState({
                              user: { ...user, cpf: event.target.value },
                            });
                          }}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                        <TextField
                          id="weight"
                          label="Peso"
                          style={{ width: "100%" }}
                          value={this.state.user.weight}
                          onChange={(event) => {
                            let { user } = this.state;
                            this.setState({
                              user: { ...user, weight: event.target.value },
                            });
                          }}
                          margin="normal"
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      style={{ marginTop: 40 }}
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                    >
                      <Button
                        style={{ float: "right" }}
                        color="secondary"
                        onClick={() => this.props.navigate("/")}
                      >
                        Cancelar
                      </Button>
                      <Button
                        style={{ float: "right" }}
                        color="primary"
                        onClick={this.handleSave}
                        disabled={this.state.buttonLoading}
                        disableTouchRipple={this.state.buttonLoading}
                      >
                        {this.state.buttonLoading ? (
                          <CircularProgress
                            size={24}
                            style={{ color: "red" }}
                          />
                        ) : (
                          "Salvar"
                        )}
                      </Button>
                      <Button
                        style={{ float: "left" }}
                        variant="contained"
                        color="primary"
                        onClick={this.openModal}
                      >
                        Nova senha
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Fragment>
          )}
        </Grid>
      </Fade>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
});
const mapDispatchToProps = {
  navigate,
  msgSimple,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePassenger);



// WEBPACK FOOTER //
// ./src/routes/profilePassenger/index.js